import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Tag, Button } from "antd";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import "../styles/whatsappcloudreportdetails.css";
import qs from "qs";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { handleApiError } from "../utils/errorHandler";

const getRandomuserParams = (params) => ({
  results: params.pagination?.pageSize,
  page: params.pagination?.current,
  ...params,
});

const WhatsappCloudReportDetails = () => {
  const { id } = useParams();
  const location = useLocation();

  const navigate = useNavigate();
  const { campaignId } = location.state || {};

  const [data, setData] = useState([]);
  const [tabledata, setTableData] = useState([]);
  const [showLoader, setShowLoader] = useState();

  // State to track the selected category
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [failedTable, setFailedTable] = useState(false);

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 20,
    },
  });

  // const extractEntries = (response) => {
  //   const priority = {
  //     failed: 0,
  //     pending: 1,
  //     delivered: 2,
  //     read: 3,
  //     sent: 4,
  //   };

  //   return response.data.matchedData.map((item) => {
  //     const entry = {};
  //     const datetime = new Date(
  //       Date.parse(item.webhookResponse?.createdAt || new Date()),
  //     );

  //     entry["timestamp"] = datetime.valueOf();
  //     entry["time"] = datetime.toLocaleString("sv");
  //     entry["from"] =
  //       item.webhookResponse?.entry[0]?.changes[0]?.value?.metadata
  //         ?.display_phone_number || "";
  //     entry["to"] =
  //       item.webhookResponse?.entry[0]?.changes[0]?.value?.statuses[0]
  //         ?.recipient_id || "";
  //     entry["type"] =
  //       item.webhookResponse?.entry[0]?.changes[0]?.value?.statuses[0]
  //         ?.conversation?.origin?.type || "";
  //     entry["status"] = "failed"; // Default status
  //     entry["timeline"] = {};

  //     // Sort statuses by timestamp
  //     const sortedStatuses = (
  //       item.webhookResponse?.entry[0]?.changes[0]?.value?.statuses || []
  //     ).sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

  //     // Iterate over sorted statuses to update the status and timeline
  //     sortedStatuses.forEach((status) => {
  //       entry.timeline[status.status] = status.timestamp;
  //       entry["status"] = status.status; // Always take the last status
  //     });

  //     entry["waId"] =
  //       item.webhookResponse?.entry[0]?.changes[0]?.value?.statuses[0]?.id ||
  //       "";
  //     entry["queueId"] = item.apiResponse?.message?.queue_id || "";
  //     entry["errors"] =
  //       item.webhookResponse?.entry[0]?.changes[0]?.value?.statuses[0]
  //         ?.errors[0]?.title || [];
  //     return entry;
  //   });
  // };

  const extractEntries = (response) => {
    return response.data.matchedData.map((item) => {
      const entry = {};

      // 👉 CASE 1: webhookResponse exists
      if (item.webhookResponse) {
        const datetime = new Date(
          Date.parse(item.webhookResponse?.createdAt || new Date()),
        );

        entry["timestamp"] = datetime.valueOf();
        entry["time"] = datetime.toLocaleString("sv");

        entry["from"] =
          item.webhookResponse?.entry[0]?.changes[0]?.value?.metadata
            ?.display_phone_number || "";

        entry["to"] =
          item.webhookResponse?.entry[0]?.changes[0]?.value?.statuses[0]
            ?.recipient_id || "";

        entry["type"] =
          item.webhookResponse?.entry[0]?.changes[0]?.value?.statuses[0]
            ?.conversation?.origin?.type || "";

        entry["status"] = "failed";
        entry["timeline"] = {};

        const sortedStatuses = (
          item.webhookResponse?.entry[0]?.changes[0]?.value?.statuses || []
        ).sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

        sortedStatuses.forEach((status) => {
          entry.timeline[status.status] = status.timestamp;
          entry["status"] = status.status;
        });

        entry["waId"] =
          item.webhookResponse?.entry[0]?.changes[0]?.value?.statuses[0]?.id ||
          "";

        entry["queueId"] = item.apiResponse?.message?.queue_id || "";
        entry["errors"] =
          item.webhookResponse?.entry[0]?.changes[0]?.value?.statuses[0]
            ?.errors?.[0]?.title || "";

        entry["source"] = "webhook"; // 👈 identify source
      }

      // 👉 CASE 2: webhookResponse NULL → fallback apiResponse
      else if (item.apiResponse) {
        const datetime = new Date(item.apiResponse.createdAt);

        entry["timestamp"] = datetime.valueOf();
        entry["time"] = datetime.toLocaleString("sv");

        entry["queueId"] = item.apiResponse?.message?.queue_id || "-";

        entry["status"] = item.apiResponse?.message?.message_status || "failed";

        entry["errors"] = item.apiResponse?.response?.error?.message || "-";

        entry["createdAt"] = item.apiResponse?.createdAt;

        entry["source"] = "api"; // 👈 identify source
      }

      return entry;
    });
  };

  // const parseMatchedData = (matchedData) => {
  //   const dataSummary = {
  //     total: 0, // Total entries processed
  //     sent: 0, // Entries that had a "sent" status
  //     delivered: 0, // Entries that had a "delivered" status
  //     read: 0, // Entries that ended with "read"
  //     failed: 0, // Entries that ended with "failed"
  //     unsent: 0, // Entries that did not achieve "sent" or "delivered"
  //   };

  //   matchedData.forEach((item) => {
  //     // Extract statuses for this entry
  //     const statuses =
  //       item.webhookResponse.entry[0]?.changes[0]?.value?.statuses || [];

  //     if (statuses.length > 0) {
  //       // Increment total for each entry with statuses
  //       dataSummary.total += 1;

  //       // Check if the timeline includes specific statuses
  //       const hasSent = statuses.some((status) => status.status === "sent");
  //       const hasDelivered = statuses.some(
  //         (status) => status.status === "delivered",
  //       );

  //       if (hasSent) dataSummary.sent += 1;
  //       if (hasDelivered) dataSummary.delivered += 1;

  //       // Consider the last status for final state calculations
  //       const lastStatus = statuses[statuses.length - 1];
  //       switch (lastStatus.status) {
  //         case "read":
  //           dataSummary.read += 1;
  //           break;
  //         case "failed":
  //           dataSummary.failed += 1;
  //           break;
  //         default:
  //           break;
  //       }
  //     } else {
  //       // If no statuses, count as unsent
  //       dataSummary.unsent += 1;
  //     }
  //   });

  //   // Calculate percentages
  //   const calculatePercentage = (value) =>
  //     dataSummary.total > 0
  //       ? ((value / dataSummary.total) * 100).toFixed(1) + "%"
  //       : "0.00%";

  //   dataSummary.sentPercentage = calculatePercentage(dataSummary.sent);
  //   dataSummary.deliveredPercentage = calculatePercentage(
  //     dataSummary.delivered,
  //   );
  //   dataSummary.readPercentage = calculatePercentage(dataSummary.read);
  //   dataSummary.failedPercentage = calculatePercentage(dataSummary.failed);
  //   dataSummary.unsentPercentage = calculatePercentage(dataSummary.unsent);

  //   return dataSummary;
  // };

  const parseMatchedData = (matchedData) => {
    const dataSummary = {
      total: 0,
      sent: 0,
      delivered: 0,
      read: 0,
      failed: 0,
      unsent: 0,
    };

    matchedData.forEach((item) => {
      // 👉 CASE 1 — webhook exists
      if (item.webhookResponse) {
        const statuses =
          item.webhookResponse.entry[0]?.changes[0]?.value?.statuses || [];

        if (statuses.length > 0) {
          dataSummary.total += 1;

          const hasSent = statuses.some((s) => s.status === "sent");
          const hasDelivered = statuses.some((s) => s.status === "delivered");

          if (hasSent) dataSummary.sent += 1;
          if (hasDelivered) dataSummary.delivered += 1;

          const lastStatus = statuses[statuses.length - 1];

          switch (lastStatus.status) {
            case "read":
              dataSummary.read += 1;
              break;
            case "failed":
              dataSummary.failed += 1;
              break;
            default:
              break;
          }
        } else {
          dataSummary.unsent += 1;
        }
      }

      // 👉 CASE 2 — webhook NULL → fallback API
      else if (item.apiResponse) {
        dataSummary.total += 1;

        const apiStatus =
          item.apiResponse?.message?.message_status?.toLowerCase();

        switch (apiStatus) {
          case "sent":
            dataSummary.sent += 1;
            break;
          case "delivered":
            dataSummary.delivered += 1;
            break;
          case "read":
            dataSummary.read += 1;
            break;
          case "failed":
            dataSummary.failed += 1;
            break;
          default:
            dataSummary.unsent += 1;
        }
      }

      // 👉 CASE 3 — no webhook + no api
      else {
        dataSummary.unsent += 1;
      }
    });

    // 👉 Percentages
    const calculatePercentage = (value) =>
      dataSummary.total > 0
        ? ((value / dataSummary.total) * 100).toFixed(1) + "%"
        : "0.0%";

    dataSummary.sentPercentage = calculatePercentage(dataSummary.sent);
    dataSummary.deliveredPercentage = calculatePercentage(
      dataSummary.delivered,
    );
    dataSummary.readPercentage = calculatePercentage(dataSummary.read);
    dataSummary.failedPercentage = calculatePercentage(dataSummary.failed);
    dataSummary.unsentPercentage = calculatePercentage(dataSummary.unsent);

    return dataSummary;
  };

  const fetchCampaignReportsData = async () => {
    try {
      setShowLoader(true);
      const response = await axios.get(
        `/api/campaignscheduler/inside/get/${id}?${qs.stringify(
          getRandomuserParams(tableParams),
        )}`,
      );
      // console.log("RESPONSE", response);
      // console.log("Campaign data:", response.data.matchedData);
      const parsedData = parseMatchedData(response.data.matchedData);

      // console.log("PARSED_MATCHED_DATA:", parsedData);

      setData(parsedData);
      // Run the extraction function
      const extractedData = extractEntries(response);
      // Sort the extracted data by date & time if needed
      const sortedExtractedData = extractedData.sort(
        (a, b) => new Date(b.timestamp) - new Date(a.timestamp),
      );
      setTableData(sortedExtractedData);
    } catch (error) {
      console.error("Error fetching campaign data:", error);
      handleApiError(error, "Error fetching campaign data");
    } finally {
      setShowLoader(false);
    }
  };

  // console.log("data:", data);

  useEffect(() => {
    fetchCampaignReportsData();
  }, [JSON.stringify(tableParams)]);

  // const columns = [
  //   {
  //     title: "From",
  //     dataIndex: "from",
  //     key: "from",
  //   },
  //   {
  //     title: "To",
  //     dataIndex: "to",
  //     key: "to",
  //   },
  //   {
  //     title: "Creation Time",
  //     dataIndex: "time",
  //     key: "time",
  //   },
  //   ...(!failedTable
  //     ? [
  //         {
  //           title: "Type",
  //           dataIndex: "type",
  //           key: "type",
  //           ellipsis: true,
  //           align: "center",
  //         },
  //       ]
  //     : []),
  //   {
  //     title: "Last Status",
  //     dataIndex: "status",
  //     key: "status",
  //     align: "center",

  //     render: (status) => {
  //       let color;
  //       let x = status[0].toUpperCase() + status.slice(1);
  //       switch (x) {
  //         case "Delivered":
  //           color = "orange";
  //           break;
  //         case "Read":
  //           color = "green";
  //           break;
  //         case "Sent":
  //           color = "blue";
  //           break;
  //         case "Failed":
  //           color = "red";
  //           break;
  //         default:
  //           color = "gray";
  //       }
  //       return <Tag color={color}>{x}</Tag>;
  //     },
  //   },
  //   ...(failedTable
  //     ? [
  //         {
  //           title: "Errors",
  //           dataIndex: "errors",
  //           key: "errors",
  //           ellipsis: true,
  //           align: "center",
  //         },
  //       ]
  //     : []),
  //   {
  //     title: "Whatsapp ID",
  //     dataIndex: "waId",
  //     key: "waId",
  //     ellipsis: true,
  //     width: 350,
  //     render: (text) => (text ? `${text.slice(0, 41)}...` : "-"),
  //   },

  //   // {
  //   //   title: "Queue Id",
  //   //   dataIndex: "queueId",
  //   //   key: "queueId",
  //   //   ellipsis: true,
  //   //   render: (text) => (text ? `${text.slice(0, 11)}...` : "-"),
  //   // },
  // ];

  // const columns = [
  //   // 👉 Show only when webhook data
  //   {
  //     title: "From",
  //     dataIndex: "from",
  //     key: "from",
  //     render: (_, record) => (record.source === "webhook" ? record.from : "-"),
  //   },
  //   {
  //     title: "To",
  //     dataIndex: "to",
  //     key: "to",
  //     render: (_, record) => (record.source === "webhook" ? record.to : "-"),
  //   },
  //   {
  //     title: "Type",
  //     dataIndex: "type",
  //     key: "type",
  //     render: (_, record) => (record.source === "webhook" ? record.type : "-"),
  //   },

  //   // 👉 Common Status
  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     key: "status",
  //     align: "center",
  //     render: (status) => {
  //       if (!status) return "-";

  //       let color;
  //       let x = status[0].toUpperCase() + status.slice(1);

  //       switch (x) {
  //         case "Delivered":
  //           color = "orange";
  //           break;
  //         case "Read":
  //           color = "green";
  //           break;
  //         case "Sent":
  //           color = "blue";
  //           break;
  //         case "Failed":
  //           color = "red";
  //           break;
  //         default:
  //           color = "gray";
  //       }

  //       return <Tag color={color}>{x}</Tag>;
  //     },
  //   },

  //   // 👉 Queue ID (API fallback main important)
  //   {
  //     title: "Queue ID",
  //     dataIndex: "queueId",
  //     key: "queueId",
  //   },

  //   // 👉 Error Message (API fallback main important)
  //   {
  //     title: "Error Message",
  //     dataIndex: "errors",
  //     key: "errors",
  //     ellipsis: true,
  //     render: (text) => (
  //       <div
  //         style={{
  //           whiteSpace: "normal",
  //           wordBreak: "break-word",
  //           maxWidth: "300px",
  //         }}
  //       >
  //         {text || "-"}
  //       </div>
  //     ),
  //   },

  //   // 👉 WhatsApp ID only webhook
  //   {
  //     title: "Whatsapp ID",
  //     dataIndex: "waId",
  //     key: "waId",
  //     render: (_, record) =>
  //       record.source === "webhook" ? record.waId?.slice(0, 40) + "..." : "-",
  //   },
  // ];

  const allColumns = [
    {
      title: "From",
      dataIndex: "from",
      key: "from",
      dataCheckKey: "from",
    },
    {
      title: "To",
      dataIndex: "to",
      key: "to",
      dataCheckKey: "to",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      dataCheckKey: "type",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      dataCheckKey: "status",
      render: (status) => {
        if (!status) return "-";

        let color;
        let x = status[0].toUpperCase() + status.slice(1);

        switch (x) {
          case "Delivered":
            color = "orange";
            break;
          case "Read":
            color = "green";
            break;
          case "Sent":
            color = "blue";
            break;
          case "Failed":
            color = "red";
            break;
          default:
            color = "gray";
        }

        return <Tag color={color}>{x}</Tag>;
      },
    },
    {
      title: "Queue ID",
      dataIndex: "queueId",
      key: "queueId",
      dataCheckKey: "queueId",
    },
    {
      title: "Error Message",
      dataIndex: "errors",
      key: "errors",
      dataCheckKey: "errors",
      render: (text) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            maxWidth: "300px",
          }}
        >
          {text || "-"}
        </div>
      ),
    },
    {
      title: "Whatsapp ID",
      dataIndex: "waId",
      key: "waId",
      dataCheckKey: "waId",
      render: (text) => (text ? text.slice(0, 40) + "..." : "-"),
    },
  ];

  const getDynamicColumns = () => {
    if (!tabledata || tabledata.length === 0) return allColumns;

    return allColumns.filter((col) => {
      const key = col.dataCheckKey;

      // Check if ANY row has data for this column
      return tabledata.some(
        (row) => row[key] !== undefined && row[key] !== null && row[key] !== "",
      );
    });
  };

  const refreshTable = () => {
    console.log("Table refreshed!");

    // Show loader immediately
    setShowLoader(true);

    // Call the fetch function with a delay of 1 second
    setTimeout(async () => {
      await fetchCampaignReportsData(); // Ensure the fetch function completes
      setShowLoader(false); // Hide loader after the data is fetched
    }, 1000);
  };

  // const handleClick = (category) => {
  //   // console.log("Selected category:", category);
  //   if (category === "failed") {
  //     setFailedTable(true); // Reset the selected category on double click
  //     fetchFailedErrorOptions();
  //     console.log("Failed error options fetched: line 337");
  //   } else {
  //     setFailedTable(false);
  //   }
  //   setSelectedCategory(category); // Update the selected category on card click
  // };

  const handleClick = async (category) => {
    setSelectedCategory(category);

    if (category === "failed") {
      setFailedTable(true);

      // Immediately fetch failed error options
      await fetchFailedErrorOptions();
    } else {
      setFailedTable(false);
      setFailedErrorOptions([]);
      setFailedErrorFilter("all");
    }
  };

  // Filter the data based on the selected category
  const filteredData = () => {
    switch (selectedCategory) {
      case "sent":
        return tabledata.filter((item) => item.status === "sent");
      case "delivered":
        return tabledata.filter((item) => item.status === "delivered");
      case "read":
        return tabledata.filter((item) => item.status === "read");
      case "failed":
        return tabledata.filter((item) => item.status === "failed");
      default:
        return tabledata;
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setTableData([]);
    }
  };

  const getDataSource = () => {
    if (selectedCategory) {
      // If a card is selected, filter data based on the selected category
      return filteredData(selectedCategory); // Assuming filteredData filters data based on selectedCategory
    } else if (filterErrors !== "All") {
      // If an error filter is applied, return filtered data
      return filteredErrorsData();
    } else {
      // If no filter is applied, return the full data
      return tabledata;
    }
  };
  // console.log(tabledata);

  // State for selected error filter
  const [filterErrors, setFilterErrors] = useState("All");

  // Handler for dropdown filter clicks
  const handleFilterClick = (filterOption) => {
    console.log("Selected Filter:", filterOption);
    setFilterErrors(filterOption);
  };

  // Dynamically filter the data based on the selected error
  const filteredErrorsData = () => {
    if (filterErrors === "All") {
      return tabledata; // Return full data if no specific filter is applied
    }
    return tabledata.filter((item) => item.errors === filterErrors);
  };

  const handleDownloadCSV = () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You are about to download ${selectedCategory} data.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, download it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setShowLoader(true); // Show loader while fetching data

        // Define API endpoint based on the selected category
        let apiEndpoint = "";

        switch (selectedCategory) {
          case "sent":
            apiEndpoint = "sent";
            break;
          case "delivered":
            apiEndpoint = "delivered";
            break;
          case "read":
            apiEndpoint = "read";
            break;
          case "failed":
            apiEndpoint = "failed";
            break;
          default:
            apiEndpoint = "all"; // Default API for all data
            break;
        }

        // Make the API call to the selected endpoint
        axios
          .get(`api/campaignscheduler/download/${apiEndpoint}/${id}`, {
            responseType: "blob",
          })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${selectedCategory}_data.csv`); // Download file with category name
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            toast.success("File downloaded successfully!");
          })
          .catch((error) => {
            console.error("Error downloading the file:", error);
            // toast.error("Error downloading the file.");
            handleApiError(error, "Error downloading the file.");
          })
          .finally(() => setShowLoader(false)); // Hide loader after request completes
      }
    });
  };

  const [failedErrorOptions, setFailedErrorOptions] = useState([]);
  const [loadingFailedErrors, setLoadingFailedErrors] = useState(false);

  console.log(failedErrorOptions);

  // const fetchFailedErrorOptions = async () => {
  //   console.log("Fetching failed error options for campaign ID:", id);
  //   try {
  //     const res = await axios.get(`/api/campaignscheduler/errorresend/${id}`);

  //     console.log("Line number 774 printer:", res);

  //     const formatted = [
  //       { label: "All Failed", value: "all" },
  //       ...res.data.errors.map((item) => ({
  //         label: `${item.error} (${item.count})`,
  //         value: item.error,
  //       })),
  //     ];

  //     setFailedErrorOptions(formatted);
  //   } catch (err) {
  //     console.error("Failed error options fetch error:", err);
  //   }
  // };

  // const fetchFailedErrorOptions = async () => {
  //   console.log("Fetching failed error options for campaign ID:", id);

  //   setLoadingFailedErrors(true);

  //   try {
  //     const res = await axios.get(`/api/campaignscheduler/errorresend/${id}`);

  //     const formatted = [
  //       { label: "--Select--", value: "" },
  //       ...res.data.errors.map((item) => ({
  //         label: `${item.error} (${item.count})`,
  //         value: item.error,
  //       })),
  //     ];

  //     setFailedErrorOptions(formatted);
  //   } catch (err) {
  //     console.error("Failed error options fetch error:", err);

  //     // Keep Select option even if API fails
  //     setFailedErrorOptions([{ label: "--Select--", value: "" }]);
  //   } finally {
  //     setLoadingFailedErrors(false);
  //   }
  // };

  const fetchFailedErrorOptions = async () => {
    console.log("Fetching failed error options for campaign ID:", id);

    setLoadingFailedErrors(true);

    try {
      const res = await axios.get(`/api/campaignscheduler/errorresend/${id}`);

      const formatted = res.data.errors.map((error) => ({
        label: error,
        value: error,
      }));

      setFailedErrorOptions(formatted);
    } catch (err) {
      console.error("Failed error options fetch error:", err);

      setFailedErrorOptions([]);
    } finally {
      setLoadingFailedErrors(false);
    }
  };

  const [failedErrorFilter, setFailedErrorFilter] = useState("");

  const handleRetryFailed = async () => {
    const selectedLabel =
      failedErrorOptions.find((o) => o.value === failedErrorFilter)?.label ||
      "All Failed";

    const confirm = await Swal.fire({
      title: "Retry Failed Messages?",
      text: `Retry for: ${selectedLabel}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, retry",
    });

    if (!confirm.isConfirmed) return;

    let fakeProgress = 0;
    let progressInterval;

    Swal.fire({
      title: "Retrying Messages...",
      html: `
    <div style="margin-top:20px;text-align:center">
      <div id="retry-progress-text" 
           style="font-weight:600;font-size:16px;margin-bottom:10px">
        0%
      </div>

      <div style="
        width:100%;
        height:12px;
        background:#e5e7eb;
        border-radius:20px;
        overflow:hidden;
      ">
        <div id="retry-progress-bar" style="
          height:100%;
          width:0%;
          background:linear-gradient(90deg,#6366f1,#8b5cf6,#ec4899);
          border-radius:20px;
          transition:width 0.3s ease;
        "></div>
      </div>
    </div>
  `,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        const bar = document.getElementById("retry-progress-bar");
        const text = document.getElementById("retry-progress-text");

        progressInterval = setInterval(() => {
          if (fakeProgress < 90) {
            fakeProgress += 1;
            bar.style.width = fakeProgress + "%";
            text.innerText = fakeProgress + "%";
          }
        }, 40);
      },
    });

    try {
      const url =
        failedErrorFilter !== "all"
          ? `/api/campaignscheduler/resend/${id}?errorFilter=${encodeURIComponent(
              failedErrorFilter,
            )}`
          : `/api/campaignscheduler/resend/${id}`;

      const res = await axios.post(
        url,
        {},
        // {
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //   },
        // },
      );

      clearInterval(progressInterval);

      // const bar = document.getElementById("retry-progress");
      const bar = document.getElementById("retry-progress-bar");
      const text = document.getElementById("retry-progress-text");

      // bar.value = 100;
      bar.style.width = "100%";
      text.innerText = "100%";

      setTimeout(() => {
        Swal.fire({
          icon: "success",
          title: "Retry Started",
          text: `${res.data.count || 0} messages queued for retry`,
        }).then(async () => {
          setSelectedCategory("all");
          setFailedErrorFilter("all");
          // setCurrentPage(1);

          await fetchCampaignReportsData(); // 🔥 instant refresh
        });
      }, 400);
    } catch (err) {
      clearInterval(progressInterval);
      Swal.fire(
        "Error",
        err?.response?.data?.message || "Retry failed",
        "error",
      );
    }
  };

  return (
    <div className="page-content w-100">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 py-3">
                Campaign ID : {campaignId ? `${campaignId}` : "Loading..."}
              </h4>
              <button
                className="btn btn-secondary"
                onClick={() => navigate(-1)} // Go back to the previous page
              >
                ← Back
              </button>
            </div>
          </div>
        </div>
        {/* Cards */}
        <div className="container my-3">
          {/* <div className="d-flex align-items-center gap-2">
            <div>
              <h6>Quick reports</h6>
            </div>
            <div
              id="refresh-btn"
              style={{ fontSize: "25px" }}
              onClick={refreshTable}
            >
              <i class="ri-refresh-line"></i>
            </div>
          </div>
          <div>
            <button className="btn btn-primary">Search</button>
          </div> */}
          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center gap-2">
              <div>
                <h6>Quick reports</h6>
              </div>

              <div
                id="refresh-btn"
                style={{ fontSize: "25px" }}
                onClick={refreshTable}
              >
                <i className="ri-refresh-line"></i>
              </div>
            </div>

            {/* FAILED FILTER */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginLeft: "auto",
              }}
            >
              {selectedCategory === "failed" && (
                <>
                  {/* <select
                    value={failedErrorFilter}
                    onChange={(e) => setFailedErrorFilter(e.target.value)}
                    style={{
                      padding: "6px 12px",
                      borderRadius: "8px",
                      fontSize: "12px",
                      backgroundColor: "rgb(68, 142, 239)",
                      border: "1px solid rgba(68, 122, 239, 0.79)",
                      color: "rgba(255, 255, 255, 0.8)",
                      outline: "none",
                      fontWeight: "600",
                    }}
                  >
                    {failedErrorOptions.map((opt) => (
                      <option
                        key={opt.value}
                        value={opt.value}
                        style={{
                          backgroundColor: "#1a1a24",
                          color: "#fff",
                        }}
                      >
                        {opt.label}
                      </option>
                    ))}
                  </select> */}

                  {/* <select
                    value={failedErrorFilter}
                    onChange={(e) => setFailedErrorFilter(e.target.value)}
                    style={{
                      padding: "6px 12px",
                      borderRadius: "8px",
                      fontSize: "12px",
                      backgroundColor: "rgb(68, 142, 239)",
                      border: "1px solid rgba(68, 122, 239, 0.79)",
                      color: "rgba(255, 255, 255, 0.8)",
                      outline: "none",
                      fontWeight: "600",
                    }}
                  >
                    {loadingFailedErrors ? (
                      <option value="">Loading...</option>
                    ) : (
                      failedErrorOptions.map((opt) => (
                        <option
                          key={opt.value || "select"}
                          value={opt.value}
                          style={{
                            backgroundColor: "#1a1a24",
                            color: "#fff",
                          }}
                        >
                          {opt.label}
                        </option>
                      ))
                    )}
                  </select> */}

                  <select
                    value={failedErrorFilter}
                    onChange={(e) => setFailedErrorFilter(e.target.value)}
                    style={{
                      padding: "6px 12px",
                      borderRadius: "8px",
                      fontSize: "16px",
                      backgroundColor: "rgb(68, 142, 239)",
                      border: "1px solid rgba(68, 122, 239, 0.79)",
                      color: "rgba(255, 255, 255, 0.8)",
                      outline: "none",
                      fontWeight: "600",
                    }}
                  >
                    <option value="">--Select--</option>

                    {loadingFailedErrors ? (
                      <option value="" disabled>
                        Loading...
                      </option>
                    ) : (
                      failedErrorOptions
                        .filter((opt) => opt.value !== "")
                        .map((opt) => (
                          <option
                            key={opt.value}
                            value={opt.value}
                            style={{
                              backgroundColor: "#1a1a24",
                              color: "#fff",
                            }}
                          >
                            {opt.label}
                          </option>
                        ))
                    )}
                  </select>

                  <button
                    onClick={handleRetryFailed}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      padding: "6px 12px",
                      borderRadius: "8px",
                      backgroundColor: "rgb(68, 142, 239)",
                      border: "1px solid rgba(68, 122, 239, 0.79)",
                      color: "rgba(255, 255, 255, 0.8)",
                      fontSize: "16px",
                      cursor: "pointer",
                      fontWeight: "600",
                    }}
                  >
                    Retry
                    <i className="ri-refresh-line" />
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="card-container my-3">
            <div className="campcard all" onClick={() => handleClick("all")}>
              <div className="icon">🔔</div>
              <div className="d-flex align-items-center gap-2">
                <h6 className="fs-6">All</h6>
                <div className="textpercentage">
                  {showLoader ? (
                    <div className="loader">Loading...</div>
                  ) : (
                    <>
                      <div className="percentage">100%</div>
                      <div className="count">({data.total || 0})</div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="campcard sent" onClick={() => handleClick("sent")}>
              <div className="icon">✔️</div>
              <div className="d-flex align-items-center gap-2">
                <h6 className="fs-6">Sent</h6>
                <div className="textpercentage">
                  {showLoader ? (
                    <div className="loader">Loading...</div>
                  ) : (
                    <>
                      <div className="percentage">{data.sentPercentage}</div>
                      <div className="count">({data.sent || 0})</div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div
              className="campcard delivered"
              onClick={() => handleClick("delivered")}
            >
              <div className="icon">
                <span className="tick1">✔</span>
                <span className="tick2">✔</span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <h6 className="fs-6">Delivered</h6>
                <div className="textpercentage">
                  {showLoader ? (
                    <div className="loader">Loading...</div>
                  ) : (
                    <>
                      <div className="percentage">
                        {data.deliveredPercentage}
                      </div>
                      <div className="count">({data.delivered || 0})</div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="campcard read" onClick={() => handleClick("read")}>
              <div className="icon">✔</div>
              <div className="d-flex align-items-center gap-2">
                <h6 className="fs-6">Read</h6>
                <div className="textpercentage">
                  {showLoader ? (
                    <div className="loader">Loading...</div>
                  ) : (
                    <>
                      <div className="percentage">{data.readPercentage}</div>
                      <div className="count">({data.read || 0})</div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div
              className="campcard failed"
              onClick={() => handleClick("failed")}
            >
              <div className="icon">❌</div>
              <div className="d-flex align-items-center gap-2">
                <h6 className="fs-6">Failed</h6>
                <div className="textpercentage">
                  {showLoader ? (
                    <div className="loader">Loading...</div>
                  ) : (
                    <>
                      <div className="percentage">{data.failedPercentage}</div>
                      <div className="count">({data.failed || 0})</div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="container my-5">
          <h6>Table reports</h6>

          <div className="row">
            <div className="col-xxl-12">
              <div id="contactList" className="card">
                <div className="card-header py-3">
                  <div className="d-flex align-items-center flex-wrap gap-2">
                    <div className="d-flex flex-wrap flex-grow-1 gap-2">
                      {/* Name */}
                    </div>
                    <div className="flex-shrink-0">
                      {/* {failedTable ? (
                        <>
                          <div className="dropdown">
                            <button
                              className="btn btn-primary d-flex align-items-center gap-2 dropdown-toggle"
                              type="button"
                              id="dropdownFilterButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Filter
                            </button>
                            <ul
                              className="dropdown-menu"
                              aria-labelledby="dropdownFilterButton"
                            >
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => handleFilterClick("All")}
                                >
                                  All
                                </button>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() =>
                                    handleFilterClick("Message undeliverable")
                                  }
                                >
                                  Message undeliverable
                                </button>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => handleFilterClick("Error 2")}
                                >
                                  Error 2
                                </button>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => handleFilterClick("Error 3")}
                                >
                                  Error 3
                                </button>
                              </li>
                            </ul>
                          </div>
                        </>
                      ) : (
                        ""
                      )} */}
                      {/* <button
                        className="btn btn-success btn-sm"
                        onClick={handleDownloadCSV}
                        type="primary"
                      >
                        Download
                        {selectedCategory.charAt(0).toUpperCase() +
                          selectedCategory.slice(1)}{" "}
                        Data
                      </button> */}
                    </div>
                  </div>
                  <div className="d-flex align-items-center flex-wrap gap-2 mt-2">
                    <div className="flex-shrink-0">
                      <div className="hstack text-nowrap gap-2 align-item-center"></div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <Table
                    dataSource={getDataSource()}
                    // columns={columns}
                    columns={getDynamicColumns()}
                    rowKey="_id"
                    loading={showLoader}
                    scroll={{ x: true }}
                    style={{
                      overflowX: tabledata.length > 5 ? "scroll" : "hidden",
                    }}
                    pagination={{
                      pageSize: tableParams.pagination.pageSize,
                      position: "bottomRight",
                      showSizeChanger: true,
                      showQuickJumper: true,
                      pageSizeOptions: ["5", "10", "15", "20", "50", "100"],
                    }}
                    onChange={handleTableChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsappCloudReportDetails;
